import React from 'react';
import { ConversationCardContainer } from './ConversationCardContainer';
import { gql } from '@urql/core';
import { MessagesCardFragment } from '../../../generated/spin-graphql';
import { useRouter } from 'next/router';

type Props = {
    conversations: MessagesCardFragment[][];
    selectedIndex: number;
};

gql`
    fragment Inbox on espin_message {
        ...ConversationCard
    }
`;

export const Inbox: React.FC<Props> = ({ conversations, selectedIndex }) => {
    const router = useRouter();

    return (
        <>
            {conversations.map((convMessages, index: number) => {
                return (
                    <ConversationCardContainer
                        key={`conversation-${index}`}
                        lastMessage={convMessages[convMessages.length - 1]}
                        selected={index === selectedIndex && router.query.show_admin_messages !== 'true'}
                        index={index}
                        isFake={false}
                    />
                );
            })}
        </>
    );
};
